import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Label, SecondaryTitle, Space } from '@/components';
import { ApiTransactionAPIModelTransactionTypeEnum as TransactionAPIModelTransactionTypeEnum } from '@/generated/api/fps/core';
import { Transaction } from '@/model/wallets/types';

const useStyles = makeStyles(() => ({
  container: {
    flexGrow: 1,
    minWidth: 0,
  },
  title: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}));

interface TransactionTypeLabelProps {
  value: TransactionAPIModelTransactionTypeEnum;
  type: 'singular' | 'plural';
}

export const TransactionTypeLabel: React.FC<TransactionTypeLabelProps> = ({ value, type }) => (
  <FormattedMessage id={`demo.components.transactionType.${value}.${type}`} />
);

export interface TransactionTitleProps {
  'data-test'?: string;
  value: Transaction;
}

export const TransactionTitle: React.FC<TransactionTitleProps> = ({ value, 'data-test': dataTest }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const formatAccount = (account: number): string | undefined => {
    const formatted = account.toString().match(/(\d+?)(?=(\d{4})+(?!\d)|$)/g);
    return formatted
      ? `${formatMessage({ id: 'common.components.money.currency' })} ${formatted.join(' ')}`
      : undefined;
  };
  return (
    <Space direction="vertical" className={classes.container} size={0}>
      <SecondaryTitle data-test={dataTest && `${dataTest}-title`} className={clsx(classes.title, 'ym-hide-content')}>
        {// prettier-ignore
        // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
        value.sbpInfo?.senderInfo
          || value.sbpInfo?.senderPhone
          || value.cardInfo?.cardNumber
          || formatAccount(value.accountFrom)}
      </SecondaryTitle>
      <Label data-test={dataTest && `${dataTest}-type`}>
        <TransactionTypeLabel value={value.transactionType} type="plural" />
      </Label>
    </Space>
  );
};

export default TransactionTitle;
